<template>
  <vxe-modal
    ref="modal"
    v-model="formVisible"
    :title="`${DocumentStatus}差旅费报销单`"
    width="90%"
    height="90%"
    @show="showModal"
  >
    <div class="formContainer">
      <div class="leftFormContainer">
        <el-form ref="FormRef" size="mini" :rules="rules" :model="form" :disabled="isDisabled">
          <el-row :gutter="10">
            <el-col :span="8">
              <el-form-item label="公司" prop="company">
                <el-select clearable v-model="form.company" placeholder="选择">
                  <el-option
                    v-for="i of ComBoxItems.company"
                    :key="i.name + ''"
                    :label="i.name"
                    :value="i.value"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="报销日期" prop="r_date">
                <el-date-picker
                  type="date"
                  placeholder="输入"
                  value-format="yyyy-MM-dd"
                  v-model="form.r_date"
                ></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="出差人" prop="users_names">
                <!-- <el-input placeholder="关联" v-model="form.users_names" v-readonly> </el-input> -->
                <el-input
                  placeholder="选择"
                  v-model="form.users_names"
                  v-readonly
                  clearable
                  @clear="clearFormToNull('users_names')"
                >
                  <i style="cursor: pointer;" slot="suffix" class="el-icon-search" @click="handleSelect"></i>
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="10">
            <el-col :span="8">
              <el-form-item label="出差开始日期" prop="e_begin_date">
                <el-date-picker
                  type="date"
                  placeholder="输入"
                  value-format="yyyy-MM-dd"
                  v-model="form.e_begin_date"
                ></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="出差结束日期" prop="e_end_date">
                <el-date-picker
                  type="date"
                  placeholder="输入"
                  value-format="yyyy-MM-dd"
                  v-model="form.e_end_date"
                ></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="出差天数" prop="e_day_count">
                <el-input placeholder="输入" v-model="form.e_day_count" />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="10">
            <el-col :span="24">
              <el-form-item label="出差事由" prop="subject_matter">
                <el-input placeholder="输入" v-model="form.subject_matter" />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="10">
            <el-col :span="6">
              <el-form-item label="办公费-发票数量" prop="office_count">
                <el-input placeholder="输入" v-model="form.office_count" />
              </el-form-item>
            </el-col>

            <el-col :span="6">
              <el-form-item label="办公费(元)" prop="office_expenses">
                <el-input
                  placeholder="输入"
                  v-model="form.office_expenses"
                  @input="computedTotal"
                  v-money:2="showMoney"
                />
              </el-form-item>
            </el-col>

            <el-col :span="6">
              <el-form-item label="餐费-发票数量" prop="meal_count">
                <el-input placeholder="输入" v-model="form.meal_count" />
              </el-form-item>
            </el-col>

            <el-col :span="6">
              <el-form-item label="餐费(元)" prop="meal_expenses">
                <el-input
                  placeholder="输入"
                  v-model="form.meal_expenses"
                  @input="computedTotal"
                  v-money:2="showMoney"
                />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="10">
            <el-col :span="6">
              <el-form-item label="交通费-发票数量" prop="traffic_count">
                <el-input placeholder="输入" v-model="form.traffic_count" />
              </el-form-item>
            </el-col>

            <el-col :span="6">
              <el-form-item label="交通费(元)" prop="traffic_expenses">
                <el-input
                  placeholder="输入"
                  v-model="form.traffic_expenses"
                  @input="computedTotal"
                  v-money:2="showMoney"
                />
              </el-form-item>
            </el-col>

            <el-col :span="6">
              <el-form-item label="邮电费-发票数量" prop="post_count">
                <el-input placeholder="输入" v-model="form.post_count" />
              </el-form-item>
            </el-col>

            <el-col :span="6">
              <el-form-item label="邮电费(元)" prop="post_expenses">
                <el-input
                  placeholder="输入"
                  v-model="form.post_expenses"
                  @input="computedTotal"
                  v-money:2="showMoney"
                />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="10">
            <el-col :span="6">
              <el-form-item label="检定费-发票数量" prop="check_count">
                <el-input placeholder="输入" v-model="form.check_count" />
              </el-form-item>
            </el-col>

            <el-col :span="6">
              <el-form-item label="检定费(元)" prop="check_expenses">
                <el-input
                  placeholder="输入"
                  v-model="form.check_expenses"
                  @input="computedTotal"
                  v-money:2="showMoney"
                />
              </el-form-item>
            </el-col>

            <el-col :span="6">
              <el-form-item label="其他-发票数量" prop="other_count">
                <el-input placeholder="输入" v-model="form.other_count" />
              </el-form-item>
            </el-col>

            <el-col :span="6">
              <el-form-item label="其他费用(元)" prop="other_expenses">
                <el-input
                  placeholder="输入"
                  v-model="form.other_expenses"
                  @input="computedTotal"
                  v-money:2="showMoney"
                />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="10">
            <!-- <el-col :span="6">
              <el-form-item label="误餐补助(元)" prop="meal_allowance">
                <el-input
                  placeholder="输入"
                  v-model="form.meal_allowance"
                  @input="computedTotal"
                  v-money:2="showMoney"
                />
              </el-form-item>
            </el-col> -->

            <!-- <el-col :span="6">
              <el-form-item label="公杂费(元)" prop="miscellaneous_expenses">
                <el-input
                  placeholder="输入"
                  v-model="form.miscellaneous_expenses"
                  @input="computedTotal"
                  v-money:2="showMoney"
                />
              </el-form-item>
            </el-col> -->

            <!-- <el-col :span="6">
              <el-form-item label="明细数量">
                <el-input placeholder="关联获取" v-model="form.detail_count" v-readonly />
              </el-form-item>
            </el-col> -->

            <el-col :span="6">
              <el-form-item label="明细费用(元)">
                <el-input
                  placeholder="关联获取"
                  disabled
                  v-readonly
                  v-model="form.detail_expenses"
                  v-money:2="showMoney"
                />
              </el-form-item>
            </el-col>

            <el-col :span="6">
              <el-form-item label="合计金额(元)">
                <el-input
                  placeholder="关联获取"
                  disabled
                  v-readonly
                  v-model="form.total_expenses"
                  v-money:2="showMoney"
                />
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>

        <!-- 明细table -->
        <div style="margin-bottom: 5px" v-if="!isDisabled">
          <el-button size="mini" type="primary" icon="el-icon-plus" @click="handleAdd">新增</el-button>
        </div>
        <vxe-grid
          ref="xTable"
          size="mini"
          :column-config="{ minWidth: '80px' }"
          :columns="tableColumns"
          border
          keep-source
          resizable
          :edit-rules="validRules"
          show-overflow
          :data="form.detailList"
          highlight-hover-row
          highlight-current-row
          :mouse-config="{ area: true, extension: true }"
          :edit-config="{ trigger: 'dblclick', mode: 'cell', activeMethod: activeMethod, showIcon: false }"
          :keyboard-config="{
            isArrow: true,
            isEnter: true,
            isTab: true,
            enterToTab: true,
            isClip: true,
            isEdit: true,
            editMethod: editMethod
          }"
          @cell-menu="cellContextMenuEvent"
          :menu-config="{ body: { options: bodyMenus }, visibleMethod: visibleMethod }"
          @menu-click="contextMenuClickEvent"
          @edit-closed="editClosed"
          :clip-config="{
            pasteMethod: pasteMethod
          }"
        >
        </vxe-grid>
      </div>
      <div class="rightFormContainer">
        <FileList :ID="id" :isDisabled="isDisabled" ref="FileListRef" vuePath="Evection" />
      </div>
    </div>

    <DetailModalBtnVue
      ref="DetailModalBtnVueRef"
      menuPath="Evection"
      :parentData="this"
      @handleClick="handleClickBtn"
    />

    <!-- 财务审批 -->
    <FinancialReviewModalVue ref="FinancialReviewModalVueRef" @sureHandler="sureFinancialReview" />

    <!-- 日期输入框 -->
    <DateInput ref="DateInputRef" @sureHandler="sureBackDate" />

    <!-- 选择用户 -->
    <EmployeeSelect ref="EmployeeSelectRef" @sureBackPerson="sureBackPerson" />
  </vxe-modal>
</template>
<script>
import FileList from '@/components/Form/FileList.vue'
import DetailModalBtnVue from '@/components/common/DetailModalBtn.vue'
import FinancialReviewModalVue from '../../components/common/ReviewModal.vue'
import EmployeeSelect from '../../components/Modal/Employee/EmployeeSelect.vue'
import { getState } from '../../utils/state'
// 打印预览
import { handlePrint } from './print'

export default {
  components: {
    FileList,
    DetailModalBtnVue,
    FinancialReviewModalVue,
    EmployeeSelect
  },
  data() {
    return {
      id: -1,
      // 表单
      form: {
        detailList: [],
        id: 0,
        creator_id: 0,
        creator: '',
        createTime: '',
        manager_review: false,
        document_status: 0,
        r_date: '',
        users_id: 0,
        users_names: '',
        subject_matter: '',
        company: '',
        e_begin_date: '',
        e_end_date: '',
        e_day_count: '',
        office_count: 0,
        office_expenses: 0,
        meal_count: 0,
        meal_expenses: 0,
        traffic_count: 0,
        traffic_expenses: 0,
        post_count: 0,
        post_expenses: 0,
        check_count: 0,
        check_expenses: 0,
        other_count: 0,
        other_expenses: 0,
        last_modify_time: '',
        meal_allowance: 0,
        miscellaneous_expenses: 0,
        detail_count: 0,
        detail_expenses: 0,
        total_expenses: 0
      },
      rules: {
        company: [{ required: true, message: '请选择公司', trigger: 'change' }],
        r_date: [{ required: true, message: '请选择日期', trigger: 'change' }],
        users_names: [{ required: true, message: '请选择用户', trigger: 'change' }],
        e_begin_date: [{ required: true, message: '请输入出差开始日期', trigger: 'change' }],
        e_end_date: [{ required: true, message: '请输入出差结束日期', trigger: 'change' }],
        e_day_count: [
          { required: true, message: '请输入出差天数', trigger: 'change' },
          {
            validator: this.isInteger,
            validNumerical: this.validNumerical.greaterThanZero,
            trigger: 'change'
          }
        ],
        subject_matter: [
          { required: true, message: '请输入出差事由', trigger: 'change' },
          {
            min: 0,
            max: 256,
            message: '长度在 0 到 256 个字符',
            trigger: 'change'
          }
        ],
        office_count: [
          {
            validator: this.isInteger,
            validNumerical: this.validNumerical.nonNegative,
            trigger: 'change'
          }
        ],
        office_expenses: [
          {
            validator: this.isDecimal,
            validNumerical: this.validNumerical.nonNegative,
            length: 10,
            decimalLength: 2,
            trigger: 'change'
          }
        ],
        meal_count: [
          {
            validator: this.isInteger,
            validNumerical: this.validNumerical.nonNegative,
            trigger: 'change'
          }
        ],
        meal_expenses: [
          {
            validator: this.isDecimal,
            validNumerical: this.validNumerical.nonNegative,
            length: 10,
            decimalLength: 2,
            trigger: 'change'
          }
        ],
        traffic_count: [
          {
            validator: this.isInteger,
            validNumerical: this.validNumerical.nonNegative,
            trigger: 'change'
          }
        ],
        traffic_expenses: [
          {
            validator: this.isDecimal,
            validNumerical: this.validNumerical.nonNegative,
            length: 10,
            decimalLength: 2,
            trigger: 'change'
          }
        ],
        post_count: [
          {
            validator: this.isInteger,
            validNumerical: this.validNumerical.nonNegative,
            trigger: 'change'
          }
        ],
        post_expenses: [
          {
            validator: this.isDecimal,
            validNumerical: this.validNumerical.nonNegative,
            length: 10,
            decimalLength: 2,
            trigger: 'change'
          }
        ],
        check_count: [
          {
            validator: this.isInteger,
            validNumerical: this.validNumerical.nonNegative,
            trigger: 'change'
          }
        ],
        check_expenses: [
          {
            validator: this.isDecimal,
            validNumerical: this.validNumerical.nonNegative,
            length: 10,
            decimalLength: 2,
            trigger: 'change'
          }
        ],
        other_count: [
          {
            validator: this.isInteger,
            validNumerical: this.validNumerical.nonNegative,
            trigger: 'change'
          }
        ],
        other_expenses: [
          {
            validator: this.isDecimal,
            validNumerical: this.validNumerical.nonNegative,
            length: 10,
            decimalLength: 2,
            trigger: 'change'
          }
        ],
        meal_allowance: [
          {
            validator: this.isDecimal,
            validNumerical: this.validNumerical.nonNegative,
            length: 10,
            decimalLength: 2,
            trigger: 'change'
          }
        ],
        miscellaneous_expenses: [
          {
            validator: this.isDecimal,
            validNumerical: this.validNumerical.nonNegative,
            length: 10,
            decimalLength: 2,
            trigger: 'change'
          }
        ]
      },
      // 表格单元格
      // tableColumns: [],
      // 校验规则
      validRules: {
        begin_date: [{ required: true, message: '请选择日期', trigger: 'change' }],
        // end_date: [{ required: true, message: '请选择截止日期', trigger: 'change' }],
        begin_address: [
          {
            min: 0,
            max: 32,
            message: '长度在 0 到 32 个字符',
            trigger: 'change'
          }
        ],
        end_address: [
          {
            min: 0,
            max: 32,
            message: '长度在 0 到 32 个字符',
            trigger: 'change'
          }
        ],
        traffic_type: [
          {
            min: 0,
            max: 10,
            message: '长度在 0 到 10 个字符',
            trigger: 'change'
          }
        ],
        traffic_invoice_count: [
          {
            validator: this.isInteger,
            validNumerical: this.validNumerical.nonNegative,
            trigger: 'change'
          }
        ],
        traffic_invoice_amount: [
          {
            validator: this.isDecimal,
            validNumerical: this.validNumerical.nonNegative,
            length: 10,
            decimalLength: 2,
            trigger: 'change'
          }
        ],
        stay_invoice_count: [
          {
            validator: this.isInteger,
            validNumerical: this.validNumerical.nonNegative,
            trigger: 'change'
          }
        ],
        stay_invoice_amount: [
          {
            validator: this.isDecimal,
            validNumerical: this.validNumerical.nonNegative,
            length: 10,
            decimalLength: 2,
            trigger: 'change'
          }
        ],
        memo: [
          {
            min: 0,
            max: 64,
            message: '长度在 0 到 64 个字符',
            trigger: 'change'
          }
        ],
        travel_days: [
          {
            validator: this.isInteger,
            validNumerical: this.validNumerical.nonNegative,
            trigger: 'change'
          }
        ],
        meal_allowance: [
          {
            validator: this.isDecimal,
            validNumerical: this.validNumerical.nonNegative,
            length: 8,
            decimalLength: 2,
            trigger: 'change'
          }
        ],
        miscellaneous_expenses: [
          {
            validator: this.isDecimal,
            validNumerical: this.validNumerical.nonNegative,
            length: 8,
            decimalLength: 2,
            trigger: 'change'
          }
        ]
      },
      // 右键
      bodyMenus: [
        [
          {
            code: 'traffic_type',
            name: '飞机'
          },
          {
            code: 'traffic_type',
            name: '动车/高铁'
          },
          {
            code: 'traffic_type',
            name: '大巴'
          },
          {
            code: 'traffic_type',
            name: '其他'
          },
          {
            code: 'traffic_type',
            name: '清空'
          }
        ]
      ],

      // 下拉框
      ComBoxItems: {
        company: [
          {
            name: '福州远控',
            value: '福州远控'
          },
          {
            name: '福建远控',
            value: '福建远控'
          },
          {
            name: '中心',
            value: '中心'
          },
          {
            name: '公司',
            value: '公司'
          }
        ]
      },
      formVisible: false,

      showMoney: true,
      // 右键缓存
      areas: {},
      colProperty: '',
      // 是否禁用编辑
      isDisabled: false
    }
  },
  created() {},
  methods: {
    handlePrint,
    // 获取附件
    getFileList() {
      this.$refs.FileListRef.init()
    },
    // 拒绝
    refuse() {
      this.$confirm('是否确认拒绝?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const success = await this.sureObsolete()
        if (success) {
          this.$message.success('操作成功!')

          this.$emit('updateData')
          this.BindText()
        }
      })
    },
    // 领导/总经理审批
    leaderReview() {
      this.$confirm('是否确认审批通过?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const success = await this.sureReview()
        if (success) {
          this.$message.success('操作成功!')

          this.$emit('updateData')
          this.BindText()
        }
      })
    },
    // 财务审核通过
    async sureFinancialReview(flag) {
      const success = await this.sureReview(flag)
      if (success) {
        this.$message.success('操作成功')
        this.$refs.FinancialReviewModalVueRef.formVisible = false

        this.$emit('updateData')
        this.BindText()
      }
    },

    // 财务审核 - new
    handleFinancialReview() {
      this.$confirm('是否确认审批通过?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const success = await this.sureReview()
        if (success) {
          this.$message.success('操作成功')

          this.$emit('updateData')
          this.BindText()
        }
      })
    },
    // 取消审核
    unReview() {
      this.$confirm('是否确认取消?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const success = await this.sureUnReview()
        if (success) {
          this.$message.success('取消成功!')

          this.$emit('updateData')
          this.BindText()
        }
      })
    },
    // 调用审批接口
    async sureReview(flag = false) {
      const { data: res } = await this.$http.put('/finance/travel_expenses_form/audit', [
        {
          id: this.id,
          manager_review: flag
        }
      ])
      if (!res.isSuccess) {
        this.$message.error(res.errorMessage)
        return false
      }
      return true
    },
    // 调用撤销审核
    async sureUnReview(flag = false) {
      const { data: res } = await this.$http.put('/finance/travel_expenses_form/unaudit', [
        {
          id: this.id,
          manager_review: flag
        }
      ])
      if (!res.isSuccess) {
        this.$message.error(res.errorMessage)
        return false
      }
      return true
    },
    // 调用拒绝接口
    async sureObsolete() {
      const { data: res } = await this.$http.put('/finance/travel_expenses_form/obsolete', [
        {
          id: this.id,
          manager_review: false
        }
      ])
      if (!res.isSuccess) {
        this.$message.error(res.errorMessage)
        return false
      }
      return true
    },
    // 点击底部按钮
    handleClickBtn(code) {
      switch (code) {
        case 'save':
          this.save()
          break
        case 'del':
          this.del()
          break
        case 'financialReview':
          // this.$refs.FinancialReviewModalVueRef.formVisible = true

          this.handleFinancialReview()
          break
        case 'unReview':
          this.unReview()
          break
        case 'managerReview':
        case 'leaderReview':
          this.leaderReview()
          break
        case 'refuse':
          this.refuse()
          break
        case 'close':
          this.formVisible = false
          break
        case 'printPreview':
          this.handlePrint(this.form)
          break
      }
    },
    // 计算金额合计
    computedTotal() {
      let total = 0

      const amountKey = [
        'office_expenses',
        'meal_expenses',
        'traffic_expenses',
        'post_expenses',
        'check_expenses',
        'other_expenses',
        // 'meal_allowance',
        // 'miscellaneous_expenses',
        'detail_expenses'
      ]

      for (const key of amountKey) {
        if (!isNaN(this.form[key])) {
          total = this.$utils.add(total, this.form[key])
        }
      }

      this.form.total_expenses = total
    },
    // 计算明细金额总额
    computedDetailTotal() {
      const tableData = this.$refs.xTable.getTableData().fullData

      let total = 0
      for (const item of tableData) {
        // 交通费
        if (!isNaN(item.traffic_invoice_amount)) {
          total = this.$utils.add(item.traffic_invoice_amount, total)
        }
        // 住宿费
        if (!isNaN(item.stay_invoice_amount)) {
          total = this.$utils.add(item.stay_invoice_amount, total)
        }
        // 误餐补助
        if (!isNaN(item.travel_days) && !isNaN(item.meal_allowance)) {
          total = this.$utils.add(this.$utils.multiply(item.travel_days, item.meal_allowance), total)
        }
        // 公杂费标准
        if (!isNaN(item.travel_days) && !isNaN(item.miscellaneous_expenses)) {
          total = this.$utils.add(this.$utils.multiply(item.travel_days, item.miscellaneous_expenses), total)
        }
      }

      this.form.detail_expenses = total

      this.$nextTick(() => {
        this.computedTotal()
      })
    },
    // 粘贴方法
    pasteMethod({ row, column, cellValue }) {
      switch (column.property) {
        case 'e_begin_date':
        case 'e_end_date':
          break
        default:
          row[column.property] = cellValue
          this.computedDetailTotal()
          break
      }
    },
    // 输入结束
    editClosed({ column }) {
      if (
        [
          'traffic_invoice_amount',
          'stay_invoice_amount',
          'travel_days',
          'meal_allowance',
          'miscellaneous_expenses'
        ].includes(column.property)
      ) {
        this.computedDetailTotal()
      }
    },
    // 出差天数变化时
    dayCountChange() {
      let user_count = 0

      if (this.form.users_names) {
        user_count = this.form.users_names.split(',').length
      }

      if (!isNaN(this.form.e_day_count)) {
        this.form.meal_allowance = this.$utils.multiply(this.form.e_day_count, this.$utils.multiply(user_count, 120))
        this.form.miscellaneous_expenses = this.$utils.multiply(
          this.form.e_day_count,
          this.$utils.multiply(user_count, 80)
        )

        this.$nextTick(() => {
          this.computedTotal()
        })
      }
    },
    // 日期返回
    sureBackDate(date) {
      this.areas.forEach(area => {
        for (let row of area.rows) {
          for (let col of area.cols) {
            if (col.property === this.colProperty) {
              row[this.colProperty] = date
            }
          }
        }
      })
    },
    // 按下右键缓存选中列
    cellContextMenuEvent({ column }) {
      this.areas = this.$refs.xTable.getCellAreas()
      this.colProperty = column.property

      if (!this.isDisabled && ['begin_date', 'end_date'].includes(column.property)) {
        this.$refs.DateInputRef.formVisible = true
      }
    },
    // 新增行
    handleAdd() {
      this.$refs.xTable.insertAt(
        {
          meal_allowance: 120,
          miscellaneous_expenses: 80
        },
        -1
      )
    },
    // 右键控制菜单方法
    visibleMethod({ options, column }) {
      // 显示之前处理按钮的操作权限
      options.forEach(list => {
        list.forEach(item => {
          item.disabled = this.isDisabled
          if (column) {
            switch (column.property) {
              case 'traffic_type':
                item.visible = true
                break
              default:
                item.visible = false
                break
            }
          } else {
            item.visible = false
          }
        })
      })
      return true
    },
    // 右键确认
    contextMenuClickEvent({ menu }) {
      const areas = this.$refs.xTable.getCellAreas()

      areas.forEach(area => {
        for (let row of area.rows) {
          for (let col of area.cols) {
            if (col.property === 'traffic_type') {
              if (menu.name === '清空') {
                row['traffic_type'] = ''
              } else {
                row['traffic_type'] = menu.name
              }
            }
          }
        }
      })
    },
    // cell激活控制
    activeMethod({ column }) {
      if (this.isDisabled) {
        return false
      }
      if (column.editRender && column.editRender.attrs && column.editRender.attrs.disabled === true) {
        return false
      }
      return true
    },
    // cell编辑控制
    editMethod({ row, column, $table }) {
      if (this.isDisabled) {
        return false
      }
      if (column.editRender && column.editRender.attrs && column.editRender.attrs.disabled === true) {
        return false
      }
      row[column.property] = null
      $table.setActiveCell(row, column.property)
      return true
    },
    // 打开模态窗
    openModal(id = 0) {
      this.id = id

      if (!this.id) {
        this.form = {
          detailList: [],
          id: 0,
          creator_id: 0,
          creator: '',
          createTime: '',
          document_status: 0,
          r_date: '',
          users_id: 0,
          users_names: '',
          subject_matter: '',
          company: '',
          e_begin_date: '',
          e_end_date: '',
          e_day_count: '',
          office_count: 0,
          office_expenses: 0,
          meal_count: 0,
          meal_expenses: 0,
          traffic_count: 0,
          traffic_expenses: 0,
          post_count: 0,
          post_expenses: 0,
          check_count: 0,
          check_expenses: 0,
          other_count: 0,
          other_expenses: 0,
          last_modify_time: '',
          meal_allowance: 0,
          miscellaneous_expenses: 0,
          detail_count: 0,
          detail_expenses: 0,
          total_expenses: 0
        }
      }

      this.$nextTick(() => {
        this.formVisible = true
      })
    },
    // 单元格设置样式,错误提示
    cellClassName({ row, column }) {
      const that = this
      var a = that.errIndex.find(item => {
        return item._XID === row._XID && item.property === column.property
      })
      if (a) {
        return 'cell-valid'
      }
    },
    async validEnter() {
      const that = this
      let flag = true
      await that.$refs.FormRef.validate().then(
        res => {
          flag = res
        },
        err => {
          flag = err
        }
      )
      that.errIndex = []
      that.removeEmptyForTable(that.$refs.xTable)
      const errMap = await that.$refs.xTable.fullValidate(true).catch(errMap => errMap)
      if (errMap) {
        Object.values(errMap).forEach(errList => {
          errList.forEach(params => {
            let { row, column, rules } = params
            rules.forEach(() => {
              that.errIndex.push({
                _XID: row._XID,
                property: column.property
              })
            })
          })
        })
        if (that.errIndex.length > 0) {
          flag = false
        }
      }
      // if (that.$refs.xTable.getTableData().tableData.length === 0) {
      //   that.$XModal.alert({
      //     message: that.messageConfig.blankDetail,
      //     status: 'warning'
      //   })
      //   return false
      // }
      if (!flag) {
        that.$message.error('验证失败,请核对输入数据')
      }
      return flag
    },
    // 保存
    save() {
      this.validEnter().then(async result => {
        if (result) {
          if (this.id && this.id > 0) {
            this.update()
          } else {
            this.add()
          }
        }
      })
    },
    // 获取数据
    async BindText() {
      const that = this
      if (that.id > 0) {
        const { data: res } = await that.$http.get('/finance/travel_expenses_form/both', {
          params: {
            id: that.id
          }
        })
        if (res.isSuccess) {
          that.form = res.data
        }
      } else {
        this.form.r_date = this.ykDateFormat('yyyy-MM-dd', new Date())
        // 用户信息赋值
        this.form.users_id = this.$store.state.userInfo.userId
        this.form.users_names = this.$store.state.userInfo.name

        this.form.creator_id = this.$store.state.userInfo.userId
        this.form.creator = this.$store.state.userInfo.name
        this.form.createTime = this.ykDateFormat('yyyy-MM-dd HH:mm:ss', new Date())
      }
      that.$nextTick(() => {
        that.$refs.FormRef.clearValidate()

        if (this.form.document_status !== 0 || this.form.creator_id !== this.$store.state.userInfo.userId) {
          this.isDisabled = true
        } else {
          this.isDisabled = false
        }
      })
    },
    // 新增
    async add() {
      const that = this
      let form = { ...that.form }
      let insertRecords = that.$refs.xTable.getInsertRecords()

      // 翻转
      insertRecords = Array.from(insertRecords).reverse()

      form.detailList = insertRecords
      form = that.removeObjectNull(form)
      form.detailList = that.removeArrayNull(form.detailList)
      const { data: res } = await that.$http.post('/finance/travel_expenses_form/both', form)
      if (res.isSuccess) {
        that.id = res.data
        that.$emit('updateData')

        this.$refs.FileListRef.handleUploadCacheFileToDB() // 提交缓存附件

        that.BindText()
        that.$message.success(that.messageConfig.save.success)
      } else {
        that.$message.error(res.errorMessage)
      }
    },
    // 更新
    async update() {
      const that = this
      let form = { ...that.form }
      let insertRecords = that.$refs.xTable.getInsertRecords()

      // 翻转
      insertRecords = Array.from(insertRecords).reverse()

      let removeRecords = that.$refs.xTable.getRemoveRecords()
      let updateRecords = that.$refs.xTable.getUpdateRecords()
      form.detailList = []
      for (let item of insertRecords) {
        form.detailList.push(item)
      }
      for (let item of removeRecords) {
        item.id = item.id > 0 ? 0 - item.id : item.id
        form.detailList.push(item)
      }
      for (let item of updateRecords) {
        form.detailList.push(item)
      }
      form = that.removeObjectNull(form)
      form.detailList = that.removeArrayNull(form.detailList)
      const { data: res } = await that.$http.put('/finance/travel_expenses_form/both', form)
      if (res.isSuccess) {
        that.$message.success(that.messageConfig.save.success)
        that.$emit('updateData')
        that.BindText()
      } else {
        that.$message.error(res.errorMessage)
      }
    },
    // 删除
    del() {
      const that = this
      this.$confirm('此操作将永久删除该单据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const { data: res } = await that.$http.delete('/finance/travel_expenses_form', {
          data: {
            id: that.id
          }
        })
        if (res.isSuccess) {
          that.$message.success(that.messageConfig.del.success)
          that.formVisible = false

          that.$emit('updateData')
        } else {
          that.$message.error(res.errorMessage)
        }
      })
    },
    // 提交缓存文件
    submitCacheFileToServer() {
      // this.$refs.FileListRef.handleUploadCacheFileToDB()
    },
    // 大写金额转换
    convertCurrency(amount) {
      if (amount == null || amount == '') {
        return ''
      }
      return this.amountLtoU(amount)
    },
    // 选择人员
    handleSelect() {
      if (!this.isDisabled) {
        this.$refs.EmployeeSelectRef.openModal(this.form.users_names)
      }
    },
    // 选择完成后
    sureBackPerson(persons) {
      this.form.users_names = persons.join(',')

      // this.dayCountChange()
    },
    // 主表选择框值改变为空时
    clearFormToNull(type) {
      switch (type) {
        case 'users_names':
          // this.dayCountChange()
          break
      }
    },
    showModal() {
      this.BindText()

      this.getFileList()
    }
  },
  computed: {
    tableColumns() {
      let columns = [
        {
          type: 'seq',
          width: '50',
          className: 'seqErrorVaildClass',
          slots: {
            default: ({ row }) => {
              if (row.ifRepeat) {
                return [
                  <el-tooltip class='tooltipItem' effect='light' content={row.repeatText} placement='right'>
                    <div style='width: 100%; height: 100%'>
                      <span>{this.$refs.xTable.getVTRowIndex(row) + 1}</span>
                    </div>
                  </el-tooltip>
                ]
              } else {
                return [<span>{this.$refs.xTable.getVTRowIndex(row) + 1}</span>]
              }
            }
          }
        }
      ]

      // 禁用
      if (!this.isDisabled) {
        columns.push({
          field: 'delete',
          title: '删除',
          width: '50',
          visible: this.isCanEdit,
          align: 'center',
          slots: {
            default: ({ row }) => {
              return [
                <i
                  id='vxeDelete'
                  class='el-icon-delete-solid'
                  onClick={() => {
                    this.removeRowForTable(row, this.$refs.xTable, this.$data)
                  }}
                ></i>
              ]
            }
          }
        })
      }

      columns = [
        ...columns,
        ...[
          // {
          //   title: '日期',
          //   children: [
          {
            field: 'begin_date',
            title: '日期',
            minWidth: '90px',
            formatter: ['formatDate', 'yyyy-MM-dd'],
            editRender: { name: '$input', attrs: { disabled: true } },
            slots: {
              header: ({ column }) => {
                return [
                  <span>
                    {column.title}
                    &nbsp;
                    <i class='iconfont col-iconfont fjyk-mouseR' />
                  </span>
                ]
              }
            }
          },
          // {
          //   field: 'end_date',
          //   title: '截止',
          //   minWidth: '90px',
          //   formatter: ['formatDate', 'yyyy-MM-dd'],
          //   editRender: { name: '$input', attrs: { disabled: true } },
          //   slots: {
          //     header: ({ column }) => {
          //       return [
          //         <span>
          //           {column.title}
          //           &nbsp;
          //           <i class='iconfont col-iconfont fjyk-mouseR' />
          //         </span>
          //       ]
          //     }
          //   }
          // }
          //   ]
          // },
          {
            title: '地点',
            children: [
              {
                field: 'begin_address',
                title: '出发',
                editRender: { name: 'input' },
                slots: {
                  header: ({ column }) => {
                    return [
                      <span>
                        {column.title}
                        &nbsp;
                        <i class='iconfont col-iconfont fjyk-tianxie' />
                      </span>
                    ]
                  }
                }
              },
              {
                field: 'end_address',
                title: '到达',
                editRender: { name: 'input' },
                slots: {
                  header: ({ column }) => {
                    return [
                      <span>
                        {column.title}
                        &nbsp;
                        <i class='iconfont col-iconfont fjyk-tianxie' />
                      </span>
                    ]
                  }
                }
              }
            ]
          },
          {
            title: '交通费',
            children: [
              {
                field: 'traffic_type',
                title: '类别',
                editRender: { name: 'input' },
                slots: {
                  header: ({ column }) => {
                    return [
                      <span>
                        {column.title}
                        &nbsp;
                        <i class='iconfont col-iconfont fjyk-tianxie' />
                        &nbsp;
                        <i class='iconfont col-iconfont fjyk-mouseR' />
                      </span>
                    ]
                  }
                }
              },
              {
                field: 'traffic_invoice_count',
                title: '票据数',
                editRender: { name: 'input' },
                slots: {
                  header: ({ column }) => {
                    return [
                      <span>
                        {column.title}
                        &nbsp;
                        <i class='iconfont col-iconfont fjyk-tianxie' />
                      </span>
                    ]
                  }
                }
              },
              {
                field: 'traffic_invoice_amount',
                title: '含税金额(元)',
                minWidth: '110px',
                editRender: { name: 'input' },
                formatter: ['formatAmount', '2', this.showMoney],
                align: 'right',
                headerAlign: 'center',
                cellType: 'string',
                slots: {
                  header: ({ column }) => {
                    return [
                      <span>
                        {column.title}
                        &nbsp;
                        <i class='iconfont col-iconfont fjyk-tianxie' />
                      </span>
                    ]
                  }
                }
              }
            ]
          },
          {
            title: '住宿费',
            children: [
              {
                field: 'stay_invoice_count',
                title: '票据数',
                editRender: { name: 'input' },
                slots: {
                  header: ({ column }) => {
                    return [
                      <span>
                        {column.title}
                        &nbsp;
                        <i class='iconfont col-iconfont fjyk-tianxie' />
                      </span>
                    ]
                  }
                }
              },
              {
                field: 'stay_invoice_amount',
                title: '含税⾦额(元)',
                minWidth: '110px',
                editRender: { name: 'input' },
                formatter: ['formatAmount', '2', this.showMoney],
                align: 'right',
                headerAlign: 'center',
                cellType: 'string',
                slots: {
                  header: ({ column }) => {
                    return [
                      <span>
                        {column.title}
                        &nbsp;
                        <i class='iconfont col-iconfont fjyk-tianxie' />
                      </span>
                    ]
                  }
                }
              }
            ]
          },
          {
            field: 'travel_days',
            title: '天数',
            editRender: { name: 'input' },
            slots: {
              header: ({ column }) => {
                return [
                  <span>
                    {column.title}
                    &nbsp;
                    <i class='iconfont col-iconfont fjyk-tianxie' />
                  </span>
                ]
              }
            }
          },
          {
            field: 'meal_allowance',
            title: '误餐补助标准/天',
            editRender: { name: 'input' },
            slots: {
              header: ({ column }) => {
                return [
                  <span>
                    {column.title}
                    &nbsp;
                    <i class='iconfont col-iconfont fjyk-tianxie' />
                  </span>
                ]
              }
            }
          },
          {
            field: 'miscellaneous_expenses',
            title: '公杂费标准/天',
            editRender: { name: 'input' },
            slots: {
              header: ({ column }) => {
                return [
                  <span>
                    {column.title}
                    &nbsp;
                    <i class='iconfont col-iconfont fjyk-tianxie' />
                  </span>
                ]
              }
            }
          },
          {
            field: 'memo',
            title: '备注',
            editRender: { name: 'input' },
            slots: {
              header: ({ column }) => {
                return [
                  <span>
                    {column.title}
                    &nbsp;
                    <i class='iconfont col-iconfont fjyk-tianxie' />
                  </span>
                ]
              }
            }
          }
        ]
      ]

      return columns
    },
    // 获取状态
    DocumentStatus() {
      if (this.id === 0) {
        return ''
      }

      return `[${getState(this.form)}] `
    }
  }
}
</script>
<style lang="less" scoped>
@rightFormContainerWidth: 250px;

.bottomBtns {
  display: flex;
  justify-content: center;
  margin-top: 10px;
}
.formContainer {
  height: calc(100% - 40px - 10px - 31px);
  display: flex;
  flex-wrap: wrap;
}
.el-form-item {
  // margin: 0px !important;
  width: 100%;
  .el-input,
  .el-select,
  .el-date-picker {
    width: 100%;
  }
}
.leftFormContainer {
  height: 100%;
  width: calc(100% - @rightFormContainerWidth);

  box-sizing: border-box;
  padding: 0 10px 10px 10px;

  overflow: auto;

  /* 修改滚动条的宽度和颜色 */
  &::-webkit-scrollbar {
    width: 10px;
  }

  &::-webkit-scrollbar-track {
    background-color: #f1f1f1;
  }

  &::-webkit-scrollbar-thumb {
    background-color: #999;
  }

  /* 鼠标悬停时滚动条 thumb 的颜色 */
  &::-webkit-scrollbar-thumb:hover {
    background-color: #888;
  }
}
.rightFormContainer {
  height: 100%;
  width: @rightFormContainerWidth;
  box-sizing: border-box;
  padding: 0 10px;
}
</style>
